<template>
  <v-dialog v-model="isActive" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card class="content" style="justify-content: space-between;">
      <div class="header">
        <div class="content-header">
          <div @click="close()" class="return-screen">
            <v-icon color="white">mdi-close</v-icon>
          </div>
          <h2>Pesquisar usuário</h2>
          <div>Atrelar usuário ao orçamento selecionado</div>
        </div>
        <div class="header-search">
          <v-text-field v-model="term" v-debounce:1s="search" label="Pesquisar usuário" outlined hide-details clearable></v-text-field>
        </div>
      </div>
      <div class="list-container">
        <LazyList :items="filteredResponsibles" @load-more="loadMoreData" :has-more-data="hasMoreData">
          <template v-slot:default="{ items }">
            <v-list style="padding: 12px;">
              <v-list-item
                v-for="responsible in items"
                :key="responsible.id"
                @click="selectResponsible(responsible)"
                style="height: 72px;"
              >
                <v-list-item-avatar>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ responsible.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </LazyList>

        <div class="loader" v-if="isLoading">
          <v-row v-for="index in 15" :key="index">
            <v-col cols="12">
              <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
            </v-col>
          </v-row>
        </div>

        <div v-if="filteredResponsibles.length === 0 && !isLoading" class="no-results">
          Nenhum usuário encontrado
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import LazyList from "@/components/Common/LazyList";
import UserService from '@/services/api/user';

export default {
  name: 'ResponsibleSelector',
  emits: ['close', 'select'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LazyList,
  },
  data() {
    return {
      term: '',
      users: [],
      currentPage: 1,
      itemsPerPage: 15,
      isLoading: false,
      hasMoreData: false,
    };
  },
  computed: {
    filteredResponsibles() {
      return this.users ? this.users.filter(user =>
        user.name.toLowerCase().includes(this.term.toLowerCase())
      ) : [];
    },
  },
  watch: {
    term() {
      this.currentPage = 1;
      this.users = [];
    },
  },
  methods: {
    close() {
      this.$emit('close');

      this.term = '';
      this.users = [];
      this.currentPage = 1;
      this.isLoading = false;
    },
    selectResponsible(user) {
      this.$emit('select', user);
      this.close();
    },
    async search() {
      if (this.term.trim() === '' || this.term.length < 3) {
        this.users = [];
        return;
      }

      this.isLoading = true;

      const queryParams = {
        name: this.term,
        size: this.itemsPerPage,
        page: this.currentPage,
      };

      try {
        const response = await UserService.search(queryParams);
        const responseData = response.data;

        if (responseData && responseData.rows) {
          const newUsers = responseData.rows.filter(user => !this.users.find(c => c.id === user.id));
          this.users = [...this.users, ...newUsers];
        }

        this.currentPage = responseData.currentPage || 1;
        const totalPages = responseData.totalPages || 1;
        this.hasMoreData = this.currentPage < totalPages;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    loadMoreData() {
      if (this.hasMoreData && !this.isLoading) {
        this.currentPage += 1;
        this.search();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  overflow-y: auto;
  flex-grow: 1;

  .loader {
    padding-left: 12px;
    padding-right: 12px;
  }
}

.no-results {
  margin-top: 20px;
  color: rgba(0, 0, 0, 0.6);
  font-style: italic;
  text-align: center;
}

.header {
  width: 100%;
  z-index: 999;
  border-radius: 0px !important;

  .content-header {
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }

  .header-search {
    background-color: #F5F5F5;
    padding: 20px;
  }
}

.list-container {

  .v-list-item__avatar {
    background-color: #ccc;
    border-radius: 50%;
  }
}
</style>
